const data = [
  {
    id: 1,
    question: "What services do you offer?",
    answer:
      "I specialize in WordPress and Shopify development, including custom theme and plugin development, Shopify theme customization, WooCommerce solutions, API integrations, payment gateways, and performance optimization."
  },
  {
    id: 2,
    question: "Can you customize my existing WordPress or Shopify website?",
    answer:
      "Yes. I can customize existing WordPress themes, plugins, and page builders (Elementor, WPBakery, FSE), as well as Shopify themes using Liquid and JSON templates to match your business needs."
  },
  {
    id: 3,
    question: "Do you develop custom WordPress plugins?",
    answer:
      "Absolutely. I develop lightweight, secure, and scalable custom WordPress plugins using clean, OOP-based architecture tailored to your requirements."
  },
  {
    id: 4,
    question: "Do you work on Shopify theme customization?",
    answer:
      "Yes. I provide Shopify theme customization, including custom sections and blocks, UI enhancements, Liquid development, and performance optimization."
  },
  {
    id: 5,
    question: "How long does it take to complete a project?",
    answer:
      "Project timelines depend on scope and complexity. A simple website may take 1–2 weeks, while advanced WordPress plugins or Shopify customizations may take longer. I share a clear timeline after reviewing requirements."
  },
  {
    id: 6,
    question: "Do you provide support and maintenance after delivery?",
    answer:
      "Yes. I offer ongoing support, updates, bug fixes, performance improvements, and maintenance for both WordPress and Shopify projects."
  },
  {
    id: 7,
    question: "Can you convert an HTML website to WordPress?",
    answer:
      "Yes. I convert static HTML/CSS websites into dynamic, SEO-friendly, and easy-to-manage WordPress websites without losing the original design."
  },
  {
    id: 8,
    question: "Do you handle website migration and hosting setup?",
    answer:
      "Yes. I handle secure website migrations, hosting setup, and server configuration using platforms like cPanel, Hostinger, WHM, and cloud hosting solutions."
  },
  {
    id: 9,
    question: "Do you integrate APIs and payment gateways?",
    answer:
      "Absolutely. I integrate third-party APIs, REST APIs, and secure payment gateways for WordPress, WooCommerce, and Shopify platforms."
  },
  {
    id: 10,
    question: "Do you use ACF for advanced WordPress functionality?",
    answer:
      "Yes. I use Advanced Custom Fields (ACF Pro) to build flexible, dynamic content structures and custom dashboards tailored for client-friendly content management."
  }
];

export default data;
